<template>
    <div>
        <div style="text-align: right">
            <Button
                :class="preCls + 'button-margin'"
                v-if="$can('update') && isShowEditBtn"
                type="primary"
                ghost
                @click="onInfoChange"
            >
                修改租客信息
            </Button>
            <Button
                :class="preCls + 'button-margin'"
                v-if="$can('record') && isShowEditRecord"
                @click="onRecordChange"
            >
                修改记录
            </Button>
        </div>
        <form-partition
            title="租客信息"
            ref="info"
            :rules="innerRules"
            :model="info"
            class="contract-content-class"
        >
            <loading-animation v-if="loading" minHeight="168" />
            <div v-else>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="cusMobile" label="手机号">
                            <Input
                                v-model="info.cusMobile"
                                :maxlength="11"
                                :readonly="cusMobileReadOnly"
                                @on-change="onCusMobileSearch"
                            />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem prop="cusType" label="租客身份">
                            <check-tag-group
                                v-model="cusType"
                                style="display: inline-block"
                                color="primary"
                                :disabled="disabledCusType"
                                @on-change="onCusTypeChange"
                            >
                                <check-tag
                                    v-for="item in dict.cusType.toList()"
                                    :name="item.id"
                                    :key="item.id"
                                    >{{ item.text }}</check-tag
                                >
                            </check-tag-group>
                        </FormItem></Col
                    >
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="cusName" label="租客姓名">
                            <Input v-model="info.cusName" />
                        </FormItem>
                        <!-- 供收集 -->
                        <FormItem
                            prop="cusId"
                            label="租客姓名"
                            style="display: none"
                        >
                            <Input v-model="info.cusId" />
                        </FormItem>
                        <FormItem
                            prop="cusBaseId"
                            label="主库id"
                            style="display: none"
                        >
                            <Input v-model="info.cusBaseId" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem prop="credType" label="证件类型">
                            <card-type
                                spread-out
                                :credType="cred.credType"
                                :credNo="cred.credNo"
                                @on-change="onCardTypeChange"
                            />
                        </FormItem>
                    </Col>
                </Row>
                <!-- 单位 -->
                <div v-if="info.cusType === CUS_TYPE.company" class="div-class">
                    <Row :gutter="20">
                        <Col span="12">
                            <FormItem prop="comName" label="单位名称">
                                <Input
                                    v-model="info.comName"
                                    placeholder
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem prop="taxNum" label="税号">
                                <Input
                                    v-model="info.taxNum"
                                    placeholder
                                ></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="20">
                        <Col span="12">
                            <FormItem prop="addr" label="单位地址">
                                <Input v-model="info.addr" placeholder></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem prop="comTel" label="电话号码">
                                <Input
                                    v-model="info.comTel"
                                    placeholder
                                ></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="20">
                        <Col span="12">
                            <FormItem prop="bank" label="开户银行">
                                <Input v-model="info.bank" placeholder></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem prop="account" label="银行账户">
                                <Input
                                    v-model="info.account"
                                    placeholder
                                ></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </div>
                <!-- 个人 -->
                <div v-else class="div-class">
                    <Row :gutter="20">
                        <Col span="12">
                            <FormItem prop="sex" label="租客性别">
                                <Select
                                    v-if="justRead"
                                    v-model="info.sex"
                                    transfer
                                    placeholder=""
                                >
                                    <Option
                                        v-for="item in $enum
                                            .get('sex')
                                            .toList()"
                                        :key="item.value"
                                        :value="item.id"
                                        >{{ item.text }}</Option
                                    >
                                </Select>
                                <RadioGroup v-model="info.sex" v-else>
                                    <Radio
                                        v-for="(item, index) in this.$enum
                                            .get('gender')
                                            .toList()"
                                        :key="index"
                                        :label="item.id"
                                        >{{ item.text }}</Radio
                                    >
                                </RadioGroup>
                            </FormItem>
                        </Col>
                    </Row>
                </div>
                <!-- 优化字段 -->
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="cusSource" label="客户来源">
                            <Select
                                v-model="info.cusSource"
                                transfer
                                placeholder
                                :readonly="cusSourceReadOnly"
                            >
                                <Option
                                    v-for="item in cusSourceList"
                                    :key="item.value"
                                    :value="item.id"
                                >
                                    {{ item.text }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col v-if="info.cusType === CUS_TYPE.personal" span="12">
                        <FormItem prop="birthday" label="生日">
                            <Input :value="info.birthday"></Input>
                        </FormItem>
                    </Col>
                </Row>
            </div>
        </form-partition>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showChangeCusInfo"
            title="修改租客信息"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="onCusInfoClose"
        >
            <change-cus-info v-if="modal.showChangeCusInfo" :id="info.id" />
        </smart-modal>
        <smart-modal
            v-model="modal.showChangeCusRecord"
            title="合同修改记录"
            :width="960"
            :height="630"
            :maskClosable="false"
        >
            <change-cus-record
                v-if="modal.showChangeCusRecord"
                :houseName="houseName"
                :houseNo="houseNo"
                :contractId="contractId"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showCustomer"
            :title="'新增客户'"
            :width="800"
            :height="500"
            :maskClosable="false"
        >
            <c-info-yxkh-form
                v-if="modal.showCustomer"
                :form-mode="FORM_MODE.add"
                @save="onSaveCustomer"
            />
        </smart-modal>
    </div>
</template>
<script>
import { Field, AutoComplete } from 'ivux'
import Dict from '_u/dict'
import Enum from '_u/enum'
import dayjs from 'dayjs'
import { tel, idCardReg } from '_u/validate'
import ChangeCusInfo from './change-cus-info'
import ChangeCusRecord from './change-cus-record'
import { queryCusSimpleVtwo } from '@/api/customer'
import CardType from '_v/components/fields/card-type'
import LoadingAnimation from '_v/components/loading-animation'
import CInfoYxkhForm from '_v/customer/c-info-yxkh-form'

const FORM_MODE = Enum.get('FORM_MODE'),
    CONTRACT_SCENE = Enum.get('CONTRACT_SCENE'),
    CRED_TYPE = Enum.get('CRED_TYPE'),
    CUS_TYPE = Enum.get('CUS_TYPE')

export default {
    name: 'CustomerInfo',
    mixins: [Field],
    props: {
        value: {
            type: Object,
            default: () => ({
                id: '',
                cusType: '',
                cusId: '',
                cusName: '',
                cusMobile: '',
                comName: '',
                taxNum: '',
                addr: '',
                comTel: '',
                bank: '',
                account: '',
                cusSource: '',
            }),
        },
        type: {
            type: [Number, String],
            default: CONTRACT_SCENE.add, // 默认为录入合同
        },
        justRead: {
            type: Boolean,
            default: false,
        },
        populateType: {
            type: String,
            default: 'through',
        },
        // 禁用选中客户
        disabledUser: {
            type: Boolean,
            default: false,
        },
        // 禁用客户类别
        disabledCusType: {
            type: Boolean,
            default: false,
        },
        houseName: {
            type: String,
            default: '',
        },
        houseNo: {
            type: String,
            default: '',
        },
        contractId: {
            type: [String, Number],
            default: '',
        },
        isShowEditBtn: {
            type: Boolean,
            default: true,
        },
        isShowEditRecord: {
            type: Boolean,
            default: true,
        },
        cusSourceReadOnly: {
            type: Boolean,
            default: false,
        },
        cusMobileReadOnly: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        AutoComplete,
        CardType,
        ChangeCusInfo,
        ChangeCusRecord,
        LoadingAnimation,
        CInfoYxkhForm,
    },
    data() {
        return {
            loading: false,
            info: {
                id: '',
                cusType: CUS_TYPE.personal,
                cusId: '',
                cusName: '',
                cusMobile: '',
                // 单位
                comName: '',
                taxNum: '',
                addr: '',
                comTel: '',
                bank: '',
                account: '',
                cusSource: '',
                // 个人
                sex: '',
                birthday: '',
                credType: CRED_TYPE.idCard,
                credNo: '',
            },
            // 证件信息
            cred: { credType: CUS_TYPE.personal, credNo: '' },
            // 词典
            dict: {
                cusType: Dict.NULL,
                credType: Dict.NULL,
                cusSource: Dict.NULL,
            },
            // 枚举
            FORM_MODE,
            CUS_TYPE,
            // 客户列表
            customerList: [],
            modal: {
                showChangeCusInfo: false,
                showChangeCusRecord: false,
                showCustomer: false,
            },
        }
    },
    watch: {
        value: {
            handler(val) {
                Object.assign(this.info, val)
                if (this.info.cusType === CUS_TYPE.personal) {
                    this.cred.credType = this.info.credType
                    this.cred.credNo = this.info.credNo
                }
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        innerRules() {
            let rules = {}
            // 可编辑
            if (this.justRead === false) {
                // 合同新增
                if (this.type === CONTRACT_SCENE.add) {
                    // 个人
                    if (this.info.cusType === CUS_TYPE.personal) {
                        _.assign(rules, {
                            cusMobile: [
                                { required: true, message: '手机号必填' },
                                { validator: tel, message: '手机号格式不正确' },
                            ],
                            cusName: [
                                { required: true, message: '租客姓名必填' },
                            ],
                            // prettier-ignore
                            credType: {
                                credType: [
                                    { required: true, message: '证件类型不能为空', },
                                ],
                                credNo: [
                                    { required: true, message: '证件号码不能为空', },
                                    { validator: this.checkCredNo, trigger: 'blur', },
                                ],
                            },
                        })
                    }
                    // 单位
                    if (this.info.cusType === CUS_TYPE.company) {
                        _.assign(rules, {
                            cusMobile: [
                                { required: true, message: '手机号必填' },
                                { validator: tel, message: '手机号格式不正确' },
                            ],
                            comName: [
                                { required: true, message: '单位名称必填' },
                            ],
                            taxNum: [{ required: true, message: '税号必填' }],
                        })
                    }
                }
            }
            return rules
        },
        cusType: {
            get() {
                return this.info.cusType ? this.info.cusType.split(',') : []
            },
            set(val) {
                this.info.cusType = val.join(',')
            },
        },
        // 客户来源
        cusSourceList() {
            return this.dict.cusSource.toList()
        },
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([Dict.get(['cus_type', 'cred_type', 'cus_source'])])
                .then((args) => {
                    var [dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 切换客户类型
        onCusTypeChange([val]) {
            let cusId = this.info.cusId
            let cusMobile = this.info.cusMobile

            // clear
            if (val === CUS_TYPE.personal) {
                this.info.comName = ''
                this.info.taxNum = ''
                this.info.addr = ''
                this.info.comTel = ''
                this.info.bank = ''
                this.info.account = ''
            }
            if (val === CUS_TYPE.company) {
                this.info.sex = ''
                this.info.birthday = ''
            }

            // 还原客户
            if (this.disabledUser) {
                this.info.cusId = cusId
                this.info.cusMobile = cusMobile
            }
            this.$refs.info.resetValidation()
        },
        // 证件类型切换
        onCardTypeChange(val) {
            this.info.credType = val.credType
            this.info.credNo = val.credNo

            // 身份证推算生日
            var credNo = this.info.credNo || '',
                birthday = ''
            if (this.info.credType === '1' && credNo.length === 18) {
                birthday = dayjs(credNo.substring(6, 14), 'YYYYMMDD')

                if (birthday.toString() == 'Invalid Date') {
                    birthday = ''
                } else {
                    birthday = birthday.format('YYYY-MM-DD')
                }

                this.info.sex = credNo.slice(-2, -1) % 2 == 0 ? 0 : 1 // zxx:性别自动带出
            }
            this.info.birthday = birthday
        },
        onInfoChange() {
            this.modal.showChangeCusInfo = true
        },
        onRecordChange() {
            this.modal.showChangeCusRecord = true
        },
        onCusInfoClose() {
            console.log('popCus')
            this.$emit('popCus')
        },
        // 手机号客户搜索
        onCusMobileSearch(e) {
            var val = e.target.value
            // 至少11位
            if (!isNaN(val) && val.length >= 11) {
                queryCusSimpleVtwo({ cusMobile: val }).then((res) => {
                    var list = res.data?.list || []
                    //如果只获取到一个，则自动选中，并填充其它信息;
                    if (list.length === 1) {
                        this.customerList = list
                        this.onCusMobileSelect(val)
                    } else {
                        this.resetCustomer()
                    }
                })
            }
            // else {
            //     //按姓名搜索
            //     queryCusSimpleVtwo({ cusName: val }).then((res) => {
            //         var list = res.data?.list || []

            //         this.customerList = list
            //     })
            //     // this.customerList = []
            // }
        },
        // 手机号选择
        onCusMobileSelect(value) {
            var item = this.customerList.find((v) => v.cusMobile == value)
            if (item) {
                this.onSaveCustomer(item)
            }
        },
        // 新增客户
        onSaveCustomer(customer) {
            this.info.cusId = customer.id
            this.info.cusBaseId = customer.cusBaseId
            this.info.cusMobile = customer.cusMobile
            this.info.cusType = customer.cusType || CUS_TYPE.personal
            this.info.cusName = customer.cusName || ''
            this.info.comName = customer.comName || ''
            this.info.taxNum = customer.taxNum || ''
            this.info.cusSource = customer.cusSource
            this.info.sex =
                customer.idCard && customer.idCard.slice(-2, -1) % 2 == 0
                    ? 0
                    : 1 // 性别

            this.cred.credType = '1' // 身份证
            this.cred.credNo = customer.idCard
        },
        // 清空客户数据
        resetCustomer() {
            this.info.cusId = ''
            //其它项暂时不清
            // this.info.cusBaseId = ''
            // this.info.cusName = ''
            // this.info.comName = ''
            // this.info.cusSource = ''
            // this.info.sex = ''

            // this.cred.credType = '' // 身份证
            // this.cred.credNo = ''
            // this.info.birthday = ''
        },
        // 证件号码校验
        checkCredNo(rule, value, callback) {
            var credTypeText = this.dict.credType.val(this.info.credType)

            // 只校验身份证的长度，其他类型不做校验，不为空即可
            if (
                value &&
                credTypeText === '身份证' &&
                idCardReg.test(value) === false
            ) {
                return callback(
                    new Error('请输入正确的' + credTypeText + '号码')
                )
            }
            callback()
        },
    },
}
</script>
<style lang="less" scoped></style>
